(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Accessibility helper function for screen reader announcements
    function announceToScreenReader(message) {
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      announcement.textContent = message;
      document.body.appendChild(announcement);

      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 1000);
    }

    // Focus trap utility
    function trapFocus(container) {
      const focusableElements = container.querySelectorAll(
        'a, button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
      );

      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      container.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              lastElement.focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === lastElement) {
              firstElement.focus();
              e.preventDefault();
            }
          }
        }
      });
    }

    // Mobile Menu
    const menuToggles = document.querySelectorAll('.mobile-menu-toggle');
    const menuClose = document.querySelector('.mobile-menu-close');
    const mobileMenu = document.querySelector('.mobile-menu');
    const menuOverlay = document.querySelector('.mobile-menu-overlay');

    function openMenu() {
      // Check if desktop or mobile
      const isDesktop = window.innerWidth >= 768;

      if (isDesktop) {
        // Desktop: slide in from left (remove the md:-translate-x-full and add translate-x-0)
        mobileMenu.classList.remove('md:-translate-x-full');
        mobileMenu.classList.add('md:translate-x-0');
      } else {
        // Mobile: slide in from right
        mobileMenu.classList.remove('translate-x-full');
        mobileMenu.classList.add('translate-x-0');
      }

      menuOverlay.style.display = 'block';
      document.body.style.overflow = 'hidden';

      // Accessibility enhancements
      menuToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'true');
      });

      // Focus management
      mobileMenu.focus();

      // Trap focus within menu
      trapFocus(mobileMenu);
      const focusableElements = mobileMenu.querySelectorAll('a, button');
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }

      // Announce menu opening
      announceToScreenReader('Navigation menu opened');
    }

    function closeMenu() {
      // Check if desktop or mobile
      const isDesktop = window.innerWidth >= 768;

      if (isDesktop) {
        // Desktop: slide out to left
        mobileMenu.classList.remove('md:translate-x-0');
        mobileMenu.classList.add('md:-translate-x-full');
      } else {
        // Mobile: slide out to right
        mobileMenu.classList.remove('translate-x-0');
        mobileMenu.classList.add('translate-x-full');
      }

      menuOverlay.style.display = 'none';
      document.body.style.overflow = '';

      // Accessibility enhancements
      menuToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus(); // Return focus to menu button
      });

      // Announce menu closing
      announceToScreenReader('Navigation menu closed');
    }

    menuToggles.forEach((toggle) => {
      toggle.addEventListener('click', openMenu);
    });

    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMenu);
    }

    // Cart Drawer
    const cartToggles = document.querySelectorAll('.cart-drawer-toggle');
    const cartClose = document.querySelector('.cart-drawer-close');
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartOverlay = document.querySelector('.cart-drawer-overlay');

    function openCart() {
      cartDrawer.classList.remove('translate-x-full');
      cartDrawer.classList.add('translate-x-0');
      cartOverlay.style.display = 'block';
      document.body.style.overflow = 'hidden';

      // Accessibility enhancements
      cartToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'true');
      });

      // Focus management
      cartDrawer.focus();

      // Trap focus within cart drawer
      trapFocus(cartDrawer);

      // Focus on close button
      if (cartClose) {
        cartClose.focus();
      }

      // Announce cart opening to screen readers
      announceToScreenReader('Shopping cart opened');
    }

    function closeCart() {
      cartDrawer.classList.remove('translate-x-0');
      cartDrawer.classList.add('translate-x-full');
      cartOverlay.style.display = 'none';
      document.body.style.overflow = '';

      // Accessibility enhancements
      cartToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus(); // Return focus to cart button
      });

      // Announce cart closing to screen readers
      announceToScreenReader('Shopping cart closed');
    }

    cartToggles.forEach((toggle) => {
      toggle.addEventListener('click', openCart);
    });

    if (cartClose) {
      cartClose.addEventListener('click', closeCart);
    }

    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCart);
    }

    // Close drawers on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // Check if menu is open (either mobile or desktop position)
        const isDesktop = window.innerWidth >= 768;
        const menuOpen = isDesktop
          ? !mobileMenu.classList.contains('md:-translate-x-full')
          : !mobileMenu.classList.contains('translate-x-full');

        if (menuOpen) {
          closeMenu();
        }
        if (!cartDrawer.classList.contains('translate-x-full')) {
          closeCart();
        }
      }
    });

    // Cart quantity controls
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('cart-qty-increase')) {
        const variantId = e.target.getAttribute('data-variant-id');
        updateCartQuantity(variantId, 1);
      } else if (e.target.classList.contains('cart-qty-decrease')) {
        const variantId = e.target.getAttribute('data-variant-id');
        updateCartQuantity(variantId, -1);
      } else if (e.target.classList.contains('cart-item-remove') || e.target.closest('.cart-item-remove')) {
        const button = e.target.closest('.cart-item-remove') || e.target;
        const variantId = button.getAttribute('data-variant-id');
        removeFromCart(variantId);
      }
    });

    function updateCartQuantity(variantId, change) {
      // First get current quantity
      const currentQtySpan = document.querySelector(`[data-variant-id="${variantId}"] .cart-qty`);
      if (!currentQtySpan) return;

      const currentQty = parseInt(currentQtySpan.textContent);
      const newQty = Math.max(0, currentQty + change);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${variantId}&quantity=${newQty}`,
      })
        .then((response) => response.json())
        .then((cart) => {
          updateCartDrawer(cart);
        })
        .catch((error) => {
          console.error('Error updating cart:', error);
        });
    }

    function removeFromCart(variantId) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${variantId}&quantity=0`,
      })
        .then((response) => response.json())
        .then((cart) => {
          updateCartDrawer(cart);
        })
        .catch((error) => {
          console.error('Error removing from cart:', error);
        });
    }

    function updateCartDrawer(cart) {
      // Use the shared update function
      if (window.updateCartDrawerContent) {
        window.updateCartDrawerContent(cart);
      } else {
        console.log('updateCartDrawerContent function not found - keeping drawer open');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const productId = productRecommendationsSection.dataset.productId;
    const url = `/recommendations/products.json?product_id=${productId}&limit=3&intent=related`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.products && data.products.length > 0) {
          let html = '<div class="grid w-full max-w-md grid-cols-3 gap-4 md:max-w-lg md:gap-6">';

          // Show up to 3 products, excluding current product
          let productsShown = 0;
          data.products.forEach((product) => {
            if (product.id != productId && productsShown < 3) {
              html += `
                <div class="flex flex-col items-center">
                  <a
                    href="${product.url}"
                    class="block transform transition-transform duration-200 hover:-translate-y-0.5"
                  >`;

              if (product.featured_image) {
                html += `
                    <div class="mb-4 overflow-hidden">
                      <img
                        src="${product.featured_image}"
                        alt="${product.title}"
                        class="h-auto w-full object-contain transition-opacity duration-200 hover:opacity-90"
                        width="300"
                        height="300"
                        draggable="false"
                      >
                    </div>`;
              }

              html += `
                  </a>
                </div>`;
              productsShown++;
            }
          });

          html += '</div>';
          productRecommendationsSection.innerHTML = html;

          // Fade in the recommendations
          setTimeout(() => {
            productRecommendationsSection.classList.remove('opacity-0');
            productRecommendationsSection.classList.add('opacity-100');
          }, 100);
        } else {
          // Fallback: hide the section if no recommendations
          productRecommendationsSection.style.display = 'none';
        }
      })
      .catch((e) => {
        console.error('Error loading product recommendations:', e);
        // Fallback: hide the section on error
        productRecommendationsSection.style.display = 'none';
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
